import styled from "styled-components";

export const StyledPageWrap = styled.div`
  position: relative;
  width: 100%;
  background: none;
  text-align: center;
  min-height: ${({ theme }) =>
    theme.skin === "plc" ? "calc(100vh - 150px)" : ""};
  min-width: ${({ theme }) => (theme.skin === "plc" ? "400px" : "")};
  margin: ${({ theme }) => (theme.skin === "plc" ? "0 auto" : "50px auto")};
  font-size: ${({ theme }) => (theme.skin === "plc" ? "16px" : "")};
  padding: ${({ theme }) => (theme.skin === "plc" ? "10rem 0 0 0" : "20px")};
  color: ${({ theme }) => (theme.skin === "plc" ? "var(--tabletext)" : "")};

  p {
    display: block;
    font: 15px/1.5 Arial, Sans-Serif;
    color: ${({ theme }) =>
      theme.skin === "plc" ? "var(--tabletext)" : "var(--acolor)"};
    font-weight: ${({ theme }) => (theme.skin === "plc" ? "700" : "")};
    margin: 0 0 30px 0;
    margin: 50px auto;
    text-align: center;
  }
  h1 {
    font: 30px/1 Arial, Sans-Serif;
    color: ${({ theme }) =>
      theme.skin === "plc" ? "var(--tabletext)" : "var(--acolor)"};
    margin: 0 0 30px 0;
    margin: 50px auto;
    text-align: center;
    margin-top: 115px;
  }
  a {
    font: 15px/1.5 Arial, Sans-Serif;
    color: ${({ theme }) =>
      theme.skin === "plc" ? "var(--tabletext)" : "var(--acolor)"};
    margin: 0 0 30px 0;
    margin: 50px auto;
    padding: 20px 38px;
    text-align: center;
  }
  a:hover {
    color: #f2d500;
  }

  @media (min-width: 576px) {
    width: 400px;
  }
`;
